// extracted by mini-css-extract-plugin
module.exports = {"button":"CarouselArrow_button__3EHnr","right":"CarouselArrow_right__12ajY","right__recommendation":"CarouselArrow_right__recommendation__2s3bs","left":"CarouselArrow_left__1iAj0"};